import React from 'react';
import { NextSeo } from 'next-seo';
import { useTranslation } from 'src/app/i18n';
import config from 'src/config';
import InvisibleTitle from 'src/components/seo/InvisibleTitle';

const baseUrl = process.env.SITE_URL || config.baseCononicalUrl;

export const visionImages: AppPageMultimedia = {
    lightGreen: [
        {
            src: `/images/background/extreme-green-light.png`,
            alt: 'background green light'
        }
    ],
    lightPink: [
        {
            src: `/images/background/pink-light.png`,
            alt: 'background pink light'
        }
    ],
    lightPurple: [
        {
            src: `/images/background/purple-light.png`,
            alt: 'background purple light'
        }
    ],
    puzzle: [
        {
            src: `/images/vision/puzzle-top.png`,
            alt: 'dark green puzzle piece'
        },
        {
            src: `/images/vision/puzzle-bottom.png`,
            alt: 'light green puzzle piece'
        }
    ],
    video: [
        {
            src: `/video/vision/puzzle.mp4`,
            alt: 'dark green puzzle piece'
        }
    ]
};

const VisionSeo = () => {
    const { t } = useTranslation('common');
    return (
        <>
            <NextSeo
                title={t('title.vision')}
                description={t('description.vision')}
                canonical={`${baseUrl}/vision-values`}
            />
            <InvisibleTitle title={t('title.vision')} />
        </>
    );
};

export default VisionSeo;
